import { Expose } from 'class-transformer';

export default class NurseWaitlistFormError {
  nurse_id: string[] = []
  waitlist: string[] = []
  action: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}